'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)('#registrationSubmitBtn', this).click(function () {
        var _this = this;

        if (!_abp2.default.session && !(0, _jquery2.default)(this).attr('data-authenticated')) {
            (0, _ajax2.default)({
                url: '/Account/AuthenticateAnonymous',
                method: 'post',
                contentType: 'application/json',
                dataType: 'json'
            }).done(function (res) {
                (0, _jquery2.default)('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
                (0, _jquery2.default)(_this).attr('data-authenticated', 'true');
                (0, _jquery2.default)(_this).closest('form').submit();
            }).fail(function (err) {});
            return false;
        }
        return true;
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/registration.js
// module id = 1187
// module chunks = 0